<!-- @Description AI4Science-Al+再生医学辅助产品矩阵 -->
<template>
  <van-collapse v-model="activeName" accordion class="productmatrix">
    <van-collapse-item
      title="新型细胞冷冻保存液"
      name="1"
      class="productmatrix-item"
      :class="{ 'productmatrix-item-check': activeName == '1' }"
    >
      <div class="info">再生医学领域中新型细胞冷冻保存液的应用定位与核心价值作为细胞治疗的重要基础试剂，该产品广泛应用于免疫细胞、干细胞及工程化细胞(如CAR-T、CAR-NK等)的低温保存，支撑基因治疗、细胞治疗及组织工程等关键技术路径。通过优化离体活细胞的冷冻保护体系，可显著提升细胞的存活时间存活数量及功能完整性，从而保障下游临床应用与产业化过程中的细胞质量与稳定性。</div>
      <img
        v-if="productImg1"
        :src="productImg1"
        alt="新型细胞冷冻保存液"
        class="productmatrix-img"
      />
      <div class="superiority" v-if="advantageList.xbxld.length">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.xbxld"
          :key="`productmatrix-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";
import aizs from "@/../static/img/product/aizs.png";

export default {
  data() {
    return {
      product_society_superiority,
      productImg1: aizs,
      activeName: "",
      advantageList: {
        xbxld: []
      }
    };
  }
};
</script>
<style lang="less" scoped>
.productmatrix {
  width: 100%;
  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .productmatrix-item {
    padding: 0 64px;
    background: #ffffff;
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      text-align: justify;
    }
  }
  .productmatrix-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }
  .productmatrix-img {
    width: 100%;
    margin: 44px 0;
  }
  .superiority {
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .title {
      width: 100%;
      height: 36px;
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }
    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin: 0 50px 32px 0;
      > img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/digitization/productmatrix4.vue